<template>
  <div>
    <top-tab-new :tab-list="btnList" :index="activeKey" @search="switchType"></top-tab-new>
    <div style="margin-top: 24px">
      <coupon-table-list
        :columns="columns"
        :dataSource="dataSource"
        @ok="callback"
        :ipagination="ipagination" :loading="loading" :customHeaderRow="customHeaderRow" :customRow="customRow"></coupon-table-list>
    </div>

  </div>

</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { httpAction, getAction } from '@/api/manage'
  import couponTableList from "./CouponTableList";
  import TopTabNew from "../TopTabNew";
  import { returnDays } from '@/utils/util'
  export default {
    name: 'CouponTable',
    components: {TopTabNew, couponTableList},
    mixins:[JeecgListMixin, mixinDevice],
    props: {
      driverId:{
        type:Number,
        default:''
      },
      formData:{
        type:Object,
        default:{}
      }
    },data(){
      return {
        columns: [
          {
            title:'优惠卷名称',
            align:"center",
            dataIndex: 'couponName',
            width:150
          },
          {
            title:'优惠卷编码',
            align:"center",
            dataIndex: 'id',
            width:240
          },
          {
            title: '可用日期',
            align:"center",
            width:200,
            dataIndex: 'invildTime',
            customRender:function (t,r,index) {
              return r.createTime + " ~ "+t;
            }
          },
          {
            title: '有效期剩余',
            align:"center",
            width:100,
            dataIndex: 'status',
            customRender:function (t,r,index) {
              if(r.status!=0){
                return "-";
              }
              return returnDays(r.nowDate,r.invildTime);
            }
          },
          {
            title:'创建人',
            align:"center",
            width:100,
            dataIndex: 'createName',
            scopedSlots: { customRender: 'createNameSlot' }
          },
          {
            title:'创建日期',
            align:"center",
            width:140,
            dataIndex: 'createTime'
          },
          {
            title:'核销人',
            align:"center",
            width:100,
            dataIndex: 'hxName',
            scopedSlots: { customRender: 'hxNameSlot' }
          },
          {
            title:'核销日期',
            align:"center",
            width:140,
            dataIndex: 'hxTime'
          },
          {
            title:'标签',
            width:200,
            align:"center",
            dataIndex: 'couponLabel_dictText'
          },
          {
            title:'备注',
            align:"center",
            width:200,
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/dm/dmCouponDriver/list"
        },disableMixinCreated:true,
        hoverStr:'',
        activeKey:0,
        btnList:[
          {
            type:"0",
            name:"未使用",
            num:0
          },
          {
            type:"1",
            name:"已使用",
            num:0
          },
          {
            type:"2",
            name:"已过期",
            num:0
          }
        ]
      }
    },watch:{
      formData(o,n){
        this.updateNum();
      }
  }

    ,methods:{
      loadList(){
        this.queryParam = {
          status:0
        };
        this.activeKey = 0;
        this.queryParam.driverId = this.driverId;
        this.updateNum();
        this.loadData();
      },switchType(type,index){
        this.activeKey =index;
        this.queryParam.status =type
        this.loadData();
      },callback(){
        this.loadData();
        this.$emit("ok")
      },updateNum(){
        this.btnList[0].num = this.formData.unUseYhj;
        this.btnList[1].num = this.formData.useYhj;
        this.btnList[2].num = this.formData.allYhj-this.formData.unUseYhj-this.formData.useYhj
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/dm/newTable.less';
  /deep/ .hui-class td{
    color: #91929e !important;
  }

  .order-num{
    color: rgba(10, 22, 41, 1);
    font-size: 16px;
    font-weight: bold;
  }
  .order-num-active{
    color: rgba(246, 81, 96, 1);
    font-size: 16px;
    font-weight: bold;
  }
</style>